import React from "react";

import { formatNumericCurrency } from "utils";

import { Col, Row, Typography } from "components";

// If the payout is partial, preVerificationPayout can be used to show what the total payout would have been
export const PayoutInVerification = ({ payout, preVerificationPayout, caption, subCaption, rejected = false, currency }) => (
  <div className="payout-card-content">
    <Row>
      <Col lg={20} className="payout-column">
        <span data-testid="payout-overview-card-big-number-span" className={`big-number-text ${rejected ? "rejected" : ""}`}>
          {payout != null ? (typeof payout !== "string" ? formatNumericCurrency(payout, { currency }) : payout) : ""}
        </span>

        {preVerificationPayout != null ? (
          <Typography variant="paragraph-m" data-testid="payout-overview-card-rejected-total" className="rejected-total rejected">
            {formatNumericCurrency(preVerificationPayout, { currency })}
          </Typography>
        ) : null}

        <Typography variant="paragraph-m">{caption}</Typography>
        {subCaption}
      </Col>
    </Row>
  </div>
);
